module.exports = __webpack_public_path__ + "static/media/variacoes.b0956553.png";